import { Field, InputType } from 'type-graphql'
import { ViewCountKeyEnum } from '../ViewCountKeyEnum'

/**
 * Input arguments for incrementing view count.
 * Used in the incrementViewCount GraphQL mutation.
 */
@InputType()
export class IncrementViewCountArgs {
  @Field(() => ViewCountKeyEnum, { description: 'The entity type (Order, PurchaseOrder, etc.)' })
  key: ViewCountKeyEnum

  @Field(() => String, { description: 'The entity ID' })
  value: string
}
